import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { Award, Landmark, CalendarClock, Wallet } from "lucide-react";

const options = [
  {
    icon: Award,
    title: "Scholarship & Awards Programme",
    desc: "Scholarships & awards come from a variety of sources — the institute itself, reduction in fees, and sponsorship by individuals or companies. A point-based system shortlists deserving candidates. Categories:",
    points: ["Means", "Merit", "Means & Merit", "Performance", "Special category (Early Enrollment, Defence, Female, Mechatronics, Out-station, etc.)"],
  },
  {
    icon: Landmark,
    title: "Loans",
    desc: "Students who gain admission may apply for a loan to the designated PSU banks — Punjab National Bank and Central Bank of India. Interested students may contact the Office of Financial Aid for more details.",
    points: [],
  },
  {
    icon: CalendarClock,
    title: "Monthly Payment Plans",
    desc: "Fees are payable as per the fee schedule. We understand some students find it difficult to pay within the prescribed period, so Kiki provides needy students a monthly payment plan option. Need-based students may contact the Office of Financial Aid.",
    points: [],
  },
  {
    icon: Wallet,
    title: "Full Course Pre-Payment Plan",
    desc: "Parents have the possibility to pre-pay the entire 3½-year course fee at the first-year rate. Interested parents may contact the Office of Financial Aid for more information.",
    points: [],
  },
];

export default function FinancialAidPage() {
  return (
    <div data-testid="financial-aid-page">
      <PageHero
        path="financial.hero"
        kicker="Financial Aid"
        title="Quality education shouldn't be out of reach"
        subtitle="The Office of Financial Aid works on the principle that any deserving student, irrespective of financial constraints, should be able to pursue their career goals at Kiki."
      />

      <section className="py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-slate-600 leading-relaxed">
            Applicants to the 3½-year courses may apply for financial aid. There are various types of financial aid and payment
            options possible to help you pay for the course.
          </p>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 gap-7">
          {options.map((it, i) => (
            <div
              key={it.title}
              className="relative bg-white rounded-2xl p-7 border border-slate-100 shadow-sm hover:shadow-xl tilt-card animate-fade-up"
              style={{ animationDelay: `${i * 0.07}s` }}
              data-testid={`aid-${i}`}
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 h-14 w-14 rounded-xl bg-yellow-400 flex items-center justify-center">
                  <it.icon className="h-7 w-7 text-[#0B2A6B]" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-[#0B2A6B] text-xl mb-2">{it.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{it.desc}</p>
                  {it.points.length > 0 && (
                    <ul className="mt-3 space-y-1.5">
                      {it.points.map((p) => (
                        <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
                          <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-yellow-400 shrink-0" />{p}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="max-w-3xl mx-auto px-4 text-center mt-12">
          <p className="text-slate-600 text-sm mb-4">For scholarships currently being offered, check the News & Events page.</p>
          <Link to="/admissions" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-lg btn-primary" data-testid="aid-apply-btn">
            Apply & ask about financial aid
          </Link>
        </div>
      </section>
    </div>
  );
}
